import { HttpHandler } from '../../api/HttpHandler';
import { Customer } from '../types';
import { environment } from '../../enviroments';

export default async function changeDefaultPaymentMethod(paymentMethod: string, userID: string) {
  try {
    const patchedData = {
      invoice_settings: {
        default_payment_method: paymentMethod,
      },
    } as Partial<Customer>;

    await HttpHandler({
      method: 'PATCH',
      url: `${environment.PAYMENTS_URL}/customer/${userID}`,
      data: patchedData,
    });
  } catch (error: any) {
    throw new Error(error);
  }
}
